import EventBooking from './EventBooking';

export default EventBooking;
